import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface TourState {
  startSideMenu: boolean;
}

interface TourAction {
  setStartSideMenu: (start: boolean) => void;
  clearTourStore: () => void;
}

const initialState: TourState = {
  startSideMenu: false,
};

type TourStore = TourState & TourAction;

const useTourStore = create<TourStore>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        setStartSideMenu: (start: boolean) => set({ startSideMenu: start }),
        clearTourStore: () => set(initialState),
      }),
      { name: 'tour' }
    )
  )
);

export default useTourStore;
